import React from "react";

export default function PageHeader({ title, subtitle, action }) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <h1 className="font-serif text-3xl font-bold tracking-tight text-navy-900 sm:text-4xl" data-testid="page-title">
          {title}
        </h1>
        {subtitle && <p className="mt-2 max-w-2xl text-navy-500">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}
